import { useNavigate, useParams } from "react-router-dom";

import { ROUTES } from "utils/constants";

import { useWakeLockContext } from "context/WakeLock/useWakeLock";

export function useCancelSessionDialog({ cancelSession }: { cancelSession: () => void }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const { release } = useWakeLockContext();

  const handleConfirm = () => {
    release();
    if (id) {
      cancelSession();
    } else {
      navigate(ROUTES.HOME);
    }
  };

  return {
    handleConfirm,
  };
}
